import React from 'react';
import { Route } from 'react-router-dom';
import Students from '../pages/students/Students';
import StudentsArchive from '../pages/students/StudentsArchive';
import CreateStudent from '../pages/students/CreateStudent';
import EditStudent from '../pages/students/EditStudent';
import PermissionGuard from '../components/global/PermissionGuard';

const studentsRoutes = (
    <>
        <Route path="/students" element={<PermissionGuard permission="students_list"><Students /></PermissionGuard>} />
        <Route path="/students/archive" element={<PermissionGuard permission="students_archive_list"><StudentsArchive /></PermissionGuard>} />
        <Route path="/students/create" element={<PermissionGuard permission="students_create"><CreateStudent /></PermissionGuard>} />
        <Route path="/students/:id/edit" element={<PermissionGuard permission="students_edit"><EditStudent /></PermissionGuard>} />
    </>
);

export default studentsRoutes;
